export const FRIENDS_DB_KEY = 'friends-3.27'
